import { render, staticRenderFns } from "./zelf-schilderen.vue?vue&type=template&id=a3cf3f28"
import script from "./zelf-schilderen.vue?vue&type=script&lang=js"
export * from "./zelf-schilderen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports